export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    // Store auth state in a cookie so silent token renewal works in browsers
    // that block third-party cookies for the hidden iframe (the cause of
    // "monitor_window_timeout" / stuck container loads on the admin dashboard).
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['https://storage.azure.com/user_impersonation'],
};

export const storageConfig = {
  accountName: process.env.REACT_APP_STORAGE_ACCOUNT_NAME || '',
};
